export const Asset = `
<path fill-rule="evenodd" clip-rule="evenodd" d="M496.64 0L993.28 372.364L807.098 512L993.28 651.636L496.64 1024L0 651.636L186.182 512L0 372.364L496.64 0ZM496.64 906.24L837.818 651.636L729.367 571.578L496.64 744.727L263.913 570.182L155.462 651.636L496.64 906.24Z"/>
`;



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/asset.js